<div class="link-card-container">
  <div class="main-container" [routerLink]="cardLink?.main?.url">
      <p class="title">
          {{cardLink?.title | titlecase}}
      </p>
        <a class="link-title" [routerLink]="cardLink?.main?.url">
          {{cardLink?.main?.title | translate | uppercase}}
          <span class="material-icons flip-icon">keyboard_backspace</span>
        </a>
  </div>

  <div class="sub-container">
      <a class="sublink" [routerLink]="cardLink?.subLink1?.url">
        <img [src]="(cardLink?.subLink1?.icon | staticp)">
         {{cardLink?.subLink1?.title | translate}}
      </a>
      <a class="sublink" [routerLink]="cardLink?.subLink2?.url">
        <img [src]="(cardLink?.subLink2?.icon | staticp)"/>
      {{cardLink?.subLink2?.title | translate}}
    </a>
  </div>

</div>
